@use "../../styles/breakpoint.module.scss" as *;

.inner {
    gap: var(--spacer-80);
}

.valueProps {
    display: flex;
    margin-top: var(--spacer-48);
    gap: var(--spacer-16);
    text-align: left;

    @media ($below-mobile) {
        margin-top: var(--spacer-80);
    }
}

.valueProp {
    composes: fontCaption from "../../styles/composable/typography.module.css";
    margin: 0;
    color: var(--color-text-secondary);

    & picture {
        display: block;
        margin-bottom: var(--spacer-8);

        & img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            aspect-ratio: 268 / 340;
        }
    }
}

.padLeft {
    padding-left: var(--spacer-64);
}

.padRight {
    padding-right: var(--spacer-64);
}
